import { Tabs, Row, Col, Collapse } from "antd";
import { useContext } from "react";
import { Context } from "../EditorContext";
import { useDrag } from "../hooks/useDragAndDrop";

import HeadingIcon from "../Heading/HeadingIcon";
import TextIcon from "../Text/TextIcon";
import DividerIcon from "../Divider/DividerIcon";
import GridIcon from "../FormRadioGrid/GridIcon";
import HtmlIcon from "../Html/HtmlIcon";
import UrlIcon from "../Button/UrlIcon";
import ImageIcon from "../Image/ImageIcon";
import InputIcon from "../FormText/InputIcon";
import RadioIcon from "../FormOption/RadioIcon";
import CheckboxIcon from "../FormMultiOption/CheckboxIcon";
import EmailIcon from "../FormEmail/EmailIcon";
import DropdownIcon from "../FormDropdown/DropdownIcon";
import PhoneIcon from "../FormPhone/PhoneIcon";
import NumberIcon from "../FormNumber/NumberIcon";
import TermsIcon from "../FormTerms/TermsIcon";
import StarIcon from "../FormRating/StarIcon";
import DateIcon from "../FormDate/DateIcon";
import TextareaIcon from "../FormTextarea/TextareaIcon";
import CountdownIcon from "../Countdown/CountdownIcon";
import CouponIcon from "../Coupon/CouponIcon";
import ImageButton from "./ImageButton";
import FormThankyouIcon from "../FormThankyou/FormThankyouIcon";

const COMPONENTS_INFO_MAPPING = {
  heading: {
    label: "Heading",
    icon: <HeadingIcon />,
  },
  text: {
    label: "Text",
    icon: <TextIcon />,
  },
  image: {
    label: "Image",
    icon: <ImageIcon />,
  },
  divider: {
    label: "Divider",
    icon: <DividerIcon />,
  },
  html: {
    label: "HTML",
    icon: <HtmlIcon />,
  },
  button: {
    label: "Button",
    icon: <UrlIcon />,
  },
  countdown: {
    label: "Countdown",
    icon: <CountdownIcon />,
  },
  coupon: {
    label: "Coupon",
    icon: <CouponIcon />,
  },
  "form-text": {
    label: "Text input",
    icon: <InputIcon />,
  },
  "form-option": {
    label: "Option",
    icon: <RadioIcon />
  },
  "form-multi-option": {
    label: "Check box",
    icon: <CheckboxIcon />
  },
  "form-radio-grid": {
    label: "Radio grid",
    icon: <GridIcon />,
  },
  "form-email": {
    label: "Email",
    icon: <EmailIcon />,
  },
  "form-date": {
    label: "Date",
    icon: <DateIcon />
  },
  "form-number": {
    label: "Number",
    icon: <NumberIcon />
  },
  "form-url": {
    label: "Url",
    icon: <UrlIcon />
  },
  "form-textarea": {
    label: "Textarea",
    icon: <TextareaIcon />
  },
  "form-phone": {
    label: "Phone",
    icon: <PhoneIcon />
  },
  "form-dropdown": {
    label: "Dropdown",
    icon: <DropdownIcon />
  },
  "form-terms": {
    label: "Terms",
    icon: <TermsIcon />
  },
  "form-rating": {
    label: "Rating",
    icon: <StarIcon />
  },
  "form-submit-button": {
    label: "Form button",
    icon: <UrlIcon />
  },
  "form-thankyou": {
    label: "Thankyou",
    icon: <FormThankyouIcon />
  }
};

export default () => {
  const { sideContent, shareRefs } = useContext(Context);
  const contentGroup = {};
  Object.keys(sideContent.content).forEach((curr) => {
    const comps = sideContent.content[curr];
    const groupName = comps.group || "def";

    contentGroup[groupName] = contentGroup[groupName] || [];
    contentGroup[groupName].push({ ...comps, name: curr });
  });

  const getDragColProps = useDrag({
    onDragStart: () => {
      shareRefs.dragToNodeType = "col";
    },
    oonDragEnd: () => {
      
    },
  });

  const componentKeys = Object.keys(contentGroup);
  if (componentKeys.length === 1) {
    const components = contentGroup[componentKeys[0]];
    return (
      <div style={{ margin: 16 }}>
        <Row gutter={[8, 8]}>
          {components.map(({ name }) => {
            return (
              <Col span={8} key={name}>
                <ImageButton
                  label={COMPONENTS_INFO_MAPPING[name].label}
                  icon={COMPONENTS_INFO_MAPPING[name].icon}
                  {...getDragColProps(name)}
                />
              </Col>
            );
          })}
        </Row>
      </div>
    );
  }

  return (
    <Collapse expandIconPosition="end" defaultActiveKey={componentKeys}>
      {componentKeys.map((group) => {
        const componentGroups = contentGroup[group];
        return (
          <Collapse.Panel header={group} key={group}>
            <Row gutter={[8, 8]}>
              {componentGroups.map(({ name }) => {
                return (
                  <Col span={8} key={name}>
                    <ImageButton
                      label={COMPONENTS_INFO_MAPPING[name].label}
                      icon={COMPONENTS_INFO_MAPPING[name].icon}
                      {...getDragColProps(name)}
                    />
                  </Col>
                );
              })}
            </Row>
          </Collapse.Panel>
        );
      })}
    </Collapse>
  );
};
